import { AiImproverGoal } from 'apps/aiTextImprover/lib/types'
import { analyticsService } from 'utils/services/analytics'

export const AiTextImproverAnalytics = {
  logOpen: ({ hasText }: { hasText: boolean }) =>
    analyticsService.sendEvent('AI_TEXT_IMPROVER.OPEN', {
      hasText,
    }),

  logClose: () => analyticsService.sendEvent('AI_TEXT_IMPROVER.USER_ABORT'),

  logVariantSubmit: ({
    goal,
    goalValue,
    sourceText,
    improvedText,
    index,
  }: {
    goal: AiImproverGoal
    goalValue: string | null
    sourceText: string
    improvedText: string
    index: number
  }) =>
    analyticsService.sendEvent('AI_TEXT_IMPROVER.VARIANT_SUBMIT', {
      goalType: goal,
      goalValue: goalValue,
      sourceText: sourceText,
      improvedText: improvedText,
      index,
    }),

  logGenerationStart: ({ isRegenerating }: { isRegenerating: boolean }) =>
    analyticsService.sendEvent('AI_TEXT_IMPROVER.GENERATION.START', {
      isRegenerating,
    }),

  logSuccessfulGeneration: () => analyticsService.sendEvent('AI_TEXT_IMPROVER.GENERATION.SUCCESS'),

  logUnsuccessfulGeneration: () => analyticsService.sendEvent('AI_TEXT_IMPROVER.GENERATION.ERROR'),

  logAddonPromotionStepVisible: () =>
    analyticsService.sendEvent('AI_TEXT_IMPROVER.ADDON_PROMOTION_STEP.VISIBLE'),

  logRateStepVisible: () => analyticsService.sendEvent('AI_TEXT_IMPROVER.RATE_STEP.VISIBLE'),
}
